import { Box, IconButton } from "@mui/material";
import { documentPage } from "../../tripDetails/style";

const ViewModeToggle: React.FC<{
    viewMode: "cards" | "grid";
    setViewMode: (mode: "cards" | "grid") => void;
  }> = ({ viewMode, setViewMode }) => (
    <Box sx={{...documentPage.box3, marginBottom:'16px'}}>
      <IconButton
        onClick={() => setViewMode("cards")}
        sx={{
          backgroundColor:
            viewMode === "cards" ? "primary.main" : "transparent",
          color: viewMode === "cards" ? "white" : "primary.main",
          ...documentPage.iconButton,
          "&:hover": {
            backgroundColor:
              viewMode === "cards"
                ? "primary.main"
                : "rgba(0, 0, 0, 0.04)",
          },
        }}
      >
          <svg
                width="16"
                height="10"
                viewBox="0 0 16 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 0H16V2H0V0ZM0 4H16V6H0V4ZM0 8H16V10H0V8Z"
                  fill={viewMode === "cards" ? "#FFFFFF" : "#6F6F6F"}
                />
              </svg>
      </IconButton>
      <IconButton
        onClick={() => setViewMode("grid")}
        sx={{
          backgroundColor:
            viewMode === "grid" ? "primary.main" : "transparent",
          color: viewMode === "grid" ? "white" : "primary.main",
          ...documentPage.iconButton,
          "&:hover": {
            backgroundColor:
              viewMode === "grid"
                ? "primary.main"
                : "rgba(0, 0, 0, 0.04)",
          },
        }}
      >
          <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 0H6V6H0V0ZM8 0H14V6H8V0ZM0 8H6V14H0V8Z"
                  fill={viewMode === "grid" ? "#FFFFFF" : "#6F6F6F"}
                />
                <path
                  d="M14 8H8V14H14V8Z"
                  fill={viewMode === "grid" ? "#FFFFFF" : "#6F6F6F"}
                />
              </svg>
      </IconButton>
    </Box>
  );
  export default ViewModeToggle;